// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Pure rules of the signing widget: who may sign, who is left, what exactly
// is signed, and the handover note kept across a sign-out.
import { hex, sha256 } from "./der";
import { DocumentKind, RequesterSigning, SIGNING_ACTIONS, SigningRequestStatus, } from "./types";
export var isOpenForSigning = function (request, now) {
    if (now === void 0) { now = new Date(); }
    return request.status === SigningRequestStatus.Waiting &&
        (request.expires_at === null || new Date(request.expires_at).getTime() > now.getTime());
};
export var documentKindOf = function (request) { var _a, _b; return (_b = (_a = SIGNING_ACTIONS[request.action]) === null || _a === void 0 ? void 0 : _a.document) !== null && _b !== void 0 ? _b : DocumentKind.NoDocument; };
/** The viewer among the signers: the server's `is_you`, or the same user id. */
export var signerOf = function (panel, userId) {
    return panel.signers.find(function (signer) { return signer.is_you === true || signer.user_id === userId; });
};
export var isViewer = function (signer, userId) {
    return signer.is_you === true || signer.user_id === userId;
};
export var SignBlock;
(function (SignBlock) {
    SignBlock["None"] = "none";
    SignBlock["Closed"] = "closed";
    SignBlock["NoPermission"] = "no-permission";
    SignBlock["NotASigner"] = "not-a-signer";
    SignBlock["AlreadySigned"] = "already-signed";
    SignBlock["Requester"] = "requester";
})(SignBlock || (SignBlock = {}));
/** Why the viewer can't sign the request now, or `SignBlock.None`. */
export var signBlock = function (panel, userId, hasSignPermission, now) {
    if (now === void 0) { now = new Date(); }
    if (!isOpenForSigning(panel.request, now)) {
        return SignBlock.Closed;
    }
    if (!hasSignPermission) {
        return SignBlock.NoPermission;
    }
    var me = signerOf(panel, userId);
    if (me === null || me === void 0 ? void 0 : me.signed_at) {
        return SignBlock.AlreadySigned;
    }
    if (panel.request.requested_by === userId &&
        panel.rule.requester_signing === RequesterSigning.NotAllowed) {
        return SignBlock.Requester;
    }
    return me ? SignBlock.None : SignBlock.NotASigner;
};
/** The eligible people who haven't signed yet, without `exceptUserId`. */
export var pendingSigners = function (panel, exceptUserId) {
    return panel.signers.filter(function (signer) {
        return !signer.signed_at && (exceptUserId === undefined || !isViewer(signer, exceptUserId));
    });
};
export var signerName = function (signer) { return signer.display_name || signer.username; };
/** The CN of the certificate a signer signed with. */
export var signerCertificate = function (signer) {
    return signer.certificate_cn ||
        (signer.certificate_subject ? commonNameOf(signer.certificate_subject) : null);
};
/** "MARIA L. SANTOS" from "C=PH, …, CN=MARIA L. SANTOS, …"; other text as is. */
export var commonNameOf = function (subject) {
    var match = /(?:^|[,/]\s*)CN=([^,/]+)/.exec(subject);
    return match ? match[1].trim() : subject;
};
export var PayloadProblem;
(function (PayloadProblem) {
    PayloadProblem["Unparseable"] = "unparseable";
    /** Not in canonical form (sorted keys, no whitespace), or not of this domain. */
    PayloadProblem["NotCanonical"] = "not-canonical";
    /** The payload describes another request than the one shown. */
    PayloadProblem["Mismatch"] = "mismatch";
    PayloadProblem["Digest"] = "digest";
    /** The document isn't the one the signed payload names. */
    PayloadProblem["Document"] = "document";
})(PayloadProblem || (PayloadProblem = {}));
var PayloadMismatchError = /** @class */ (function (_super) {
    __extends(PayloadMismatchError, _super);
    function PayloadMismatchError(problem, message) {
        var _this = _super.call(this, message) || this;
        // The portal compiles to ES5, where an Error subclass loses its prototype: restore it
        // so `instanceof PayloadMismatchError` holds in the production build.
        Object.setPrototypeOf(_this, PayloadMismatchError.prototype);
        _this.name = "PayloadMismatchError";
        _this.problem = problem;
        return _this;
    }
    return PayloadMismatchError;
}(Error));
export { PayloadMismatchError };
/** The payload's `domain` (design §2). */
export var SIGNING_DOMAIN = "step-signing/v1";
var isRecord = function (value) {
    return !!value && typeof value === "object" && !Array.isArray(value);
};
/** Design §2's canonical JSON: sorted keys, no whitespace, no floats. */
export var canonicalJson = function (value) {
    if (Array.isArray(value)) {
        return "[".concat(value.map(canonicalJson).join(","), "]");
    }
    if (isRecord(value)) {
        return "{".concat(Object.keys(value)
            .sort()
            .map(function (key) { return "".concat(JSON.stringify(key), ":").concat(canonicalJson(value[key])); })
            .join(","), "}");
    }
    if (typeof value === "number" && !Number.isInteger(value)) {
        throw new PayloadMismatchError(PayloadProblem.NotCanonical, "a float in the payload");
    }
    return JSON.stringify(value);
};
/** How a signed value reads in the details table. */
export var displayValue = function (value) {
    if (value === null || value === undefined)
        return "";
    if (Array.isArray(value))
        return value.map(displayValue).join(", ");
    if (isRecord(value))
        return canonicalJson(value);
    return String(value);
};
var lowerString = function (value) {
    return typeof value === "string" && value ? value.toLowerCase() : null;
};
/** Subject fields of a trustee's request whose ids the panel names. */
var CEREMONY_FIELDS = ["keys_ceremony_id", "tally_session_id"];
var TRUSTEE_FIELD = "trustee_id";
/** The panel's name for a signed id, only when the panel names that very id. */
var nameOf = function (data, key, value) {
    var _a, _b;
    if (CEREMONY_FIELDS.includes(key) && data.ceremony_id && data.ceremony_id === value) {
        return (_a = data.ceremony_name) !== null && _a !== void 0 ? _a : null;
    }
    if (key === TRUSTEE_FIELD && data.request.trustee_id && data.request.trustee_id === value) {
        return (_b = data.trustee_name) !== null && _b !== void 0 ? _b : null;
    }
    return null;
};
var mismatch = function (message) { return new PayloadMismatchError(PayloadProblem.Mismatch, message); };
/**
 * What you see is what you sign: the dialog shows the canonical payload the
 * approval signs, not fields the server sent beside it. It must be in
 * canonical form, of this domain and about the request shown (id, code,
 * action, tenant, event, Post and country); the document hash on the card is
 * the one it names; and server labels only name values it holds.
 * Throws `PayloadMismatchError`.
 */
export var signedView = function (data) {
    var _a, _b, _c, _d;
    var request = data.request;
    var payload;
    try {
        payload = JSON.parse(request.canonical_payload);
    }
    catch (_e) {
        payload = undefined;
    }
    if (!isRecord(payload)) {
        throw new PayloadMismatchError(PayloadProblem.Unparseable, "the payload is not an object");
    }
    if (payload.domain !== SIGNING_DOMAIN || canonicalJson(payload) !== request.canonical_payload) {
        throw new PayloadMismatchError(PayloadProblem.NotCanonical, "the payload is not in canonical form");
    }
    var expected = {
        request_id: request.id,
        code: request.code,
        action: request.action,
        tenant_id: request.tenant_id,
        election_event_id: request.election_event_id,
        election_id: (_a = request.election_id) !== null && _a !== void 0 ? _a : null,
        area_id: (_b = request.area_id) !== null && _b !== void 0 ? _b : null,
    };
    for (var _i = 0, _f = Object.entries(expected); _i < _f.length; _i++) {
        var _g = _f[_i], field = _g[0], value = _g[1];
        if (((_c = payload[field]) !== null && _c !== void 0 ? _c : null) !== value) {
            throw mismatch("the payload's ".concat(field, " is not the request's"));
        }
    }
    var subject = payload.subject;
    if (!isRecord(subject)) {
        throw mismatch("the payload has no subject");
    }
    var documentSha256 = null;
    var kind = documentKindOf(request);
    if (kind !== DocumentKind.NoDocument) {
        documentSha256 = lowerString(kind === DocumentKind.Pdf ? subject.document_sha256 : subject.eml_sha256);
        if (!documentSha256) {
            throw new PayloadMismatchError(PayloadProblem.Document, "the payload names no document");
        }
        var shown = lowerString(request.document_sha256);
        if (shown && shown !== documentSha256) {
            throw new PayloadMismatchError(PayloadProblem.Document, "the payload names another document than the request");
        }
    }
    var labelled = ((_d = data.details) !== null && _d !== void 0 ? _d : []).map(function (detail) {
        var _a;
        if (!(detail.key in subject) || displayValue(subject[detail.key]) !== detail.value) {
            throw mismatch("the details row ".concat(detail.key, " is not what the payload signs"));
        }
        return { key: detail.key, label: (_a = detail.label) !== null && _a !== void 0 ? _a : null, value: detail.value };
    });
    var rest = Object.keys(subject)
        .filter(function (key) { return !labelled.some(function (row) { return row.key === key; }); })
        .map(function (key) { return ({ key: key, label: null, value: displayValue(subject[key]) }); });
    var rows = __spreadArray(__spreadArray([], labelled, true), rest, true).map(function (row) {
        var name = nameOf(data, row.key, subject[row.key]);
        return name ? __assign(__assign({}, row), { name: name }) : row;
    });
    return { payload: payload, subject: subject, documentSha256: documentSha256, rows: rows };
};
/**
 * The bytes the approval signs: the canonical payload exactly as the server
 * sent it, UTF-8 encoded, once `signedView` accepts it and it hashes to
 * `payload_sha256`. Throws `PayloadMismatchError`.
 */
export var payloadToSign = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var view, bytes, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                view = signedView(data);
                bytes = new TextEncoder().encode(data.request.canonical_payload);
                _a = hex;
                return [4 /*yield*/, sha256(bytes)];
            case 1:
                if (_a.apply(void 0, [_b.sent()]) !== data.request.payload_sha256.toLowerCase()) {
                    throw new PayloadMismatchError(PayloadProblem.Digest, "the canonical payload does not hash to payload_sha256");
                }
                return [2 /*return*/, { bytes: bytes, view: view }];
        }
    });
}); };
/** Checks downloaded document bytes against the hash the signed payload names. */
export var checkDocument = function (bytes, view) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = !view.documentSha256;
                if (_a) return [3 /*break*/, 2];
                _b = hex;
                return [4 /*yield*/, sha256(bytes)];
            case 1:
                _a = _b.apply(void 0, [_c.sent()]) !== view.documentSha256;
                _c.label = 2;
            case 2:
                if (_a) {
                    throw new PayloadMismatchError(PayloadProblem.Document, "the downloaded document is not the one the payload names");
                }
                return [2 /*return*/];
        }
    });
}); };
// --- Handover: the note that survives the sign-out -------------------------
export var RESUME_KEY = "signing:resume";
/** A note older than this is ignored even when the request doesn't expire sooner. */
export var RESUME_MAX_AGE_MS = 30 * 60 * 1000;
/** The note for a request, expiring with it or after 30 minutes, whichever is first. */
export var resumeFor = function (request, now) {
    if (now === void 0) { now = new Date(); }
    var limit = now.getTime() + RESUME_MAX_AGE_MS;
    var expires = request.expires_at ? new Date(request.expires_at).getTime() : limit;
    return {
        requestId: request.id,
        tenantId: request.tenant_id,
        eventId: request.election_event_id,
        expiresAt: new Date(Math.min(limit, expires)).toISOString(),
    };
};
/** Throws when the storage refuses the write (e.g. storage disabled). */
export var writeResume = function (storage, resume) {
    storage.setItem(RESUME_KEY, JSON.stringify(resume));
};
/**
 * Reads and removes the note. `null` when there is none, it isn't one of
 * ours, it is for another tenant, it has expired, or storage is unavailable.
 */
export var takeResume = function (storage, _a) {
    var tenantId = _a.tenantId, _b = _a.now, now = _b === void 0 ? new Date() : _b;
    var raw;
    try {
        raw = storage.getItem(RESUME_KEY);
        if (raw === null)
            return null;
        storage.removeItem(RESUME_KEY);
    }
    catch (_c) {
        return null;
    }
    try {
        var value = JSON.parse(raw);
        var expiresAt = typeof value.expiresAt === "string" ? Date.parse(value.expiresAt) : NaN;
        if (typeof value.requestId === "string" &&
            value.requestId &&
            typeof value.eventId === "string" &&
            value.tenantId === tenantId &&
            expiresAt > now.getTime()) {
            return {
                requestId: value.requestId,
                tenantId: value.tenantId,
                eventId: value.eventId,
                expiresAt: value.expiresAt,
            };
        }
    }
    catch (_d) {
        // Not ours: dropped.
    }
    return null;
};
